module.exports = __webpack_public_path__ + "img/CameraIndoorOutlined.45c41d73.svg";